import React from 'react';
import { Link } from 'react-router-dom';

const teamMembers = [
  { name: 'Food Security', role: 'End hunger, achieve food security and improved nutrition and promote sustainable agriculture', image: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1745836202/image_ktufp0.png', page: 'Goals' },
  { name: 'Gender Equality', role: 'Achieve gender equality and empower all women and girls', image: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1745836204/image-1_sq44nw.png', page: 'Goals' },
  { name: 'Jobs', role: 'Promote sustained, inclusive and sustainable economic growth, full and productive employment and decent work for all', image: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1745836201/image-2_ikiiwo.png', page: 'Goals' },
];

const iconUrl = 'https://res.cloudinary.com/dzngpgki4/image/upload/v1745791431/Expand_right_11_mvhgkl.png';

const Goals = () => {
  return (
    <div className='md:px-24 px-4 md:mt-14 mt-6'>

      {/* Heading */}
      <div className="flex md:gap-4 gap-1 items-center md:mb-6 mb-2">
        <h2 className="text-[#03897B] text-[10px] md:text-[32px] font-bold">
        GOALS
        </h2>
        <img
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1746386728/Expand_right_14_xsloli.png"
          alt="l"
          className="md:w-[57px] md:h-[59px] h-[13px] w-[13px]"
        />
      </div>

      {/* Grid Cards */}
      <div className="grid grid-cols-3 sm:grid-cols-3 gap-2 md:gap-4">
        {teamMembers.map((member, index) => (
          <div
            key={index}
            className="relative rounded-md overflow-hidden shadow hover:shadow-lg transition-all duration-300 transform hover:scale-105 hover:brightness-105"
          >
            <Link to={`/${member.page}`} className="block">
              {/* Image */}
              {member.image ? (
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-full h-[100px] sm:h-[240px] md:h-[350px] object-cover bg-[#D9D9D9]"
                />
              ) : (
                <div className="w-full h-[140px] sm:h-[240px] md:h-[260px] bg-[#D9D9D9]" />
              )}

       {/* Name, Paragraph, and Icon OVERLAY */}
<div className="absolute bottom-0 left-0 right-0 bg-[#03897B] text-white md:px-6 px-3 md:h-[90px] h-[45px] flex justify-between items-center mix-blend-lighten overflow-hidden">
  
  {/* Text section */}
  <div className="flex flex-col justify-center overflow-hidden max-w-[80%]">
    <p className="text-[10px] sm:text-[16px] md:text-[32px] font-medium truncate">
      {member.name}
    </p>
    <p className="text-[4px] sm:text-[14px] md:text-[12px] font-light leading-tight line-clamp-3">
      {member.role}
    </p>
  </div>

  {/* Arrow Icon */}
  <div className="flex items-center justify-center md:w-[35px] md:h-[90px] w-[20px] h-[20px] flex-shrink-0">
    <img
      src={iconUrl}
      alt="Arrow icon"
      className="w-full h-full object-contain"
    />
  </div>
</div>



            </Link>
          </div>
        ))}
      </div>

      {/* Bottom Info Section */}
      <div className="flex items-center md:space-x-1 space-x-1 md:mt-4 mt-2">
        {/* First Image */}
        <img
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745837904/image_1650_udugu6.png"
          alt="NDP Icon"
          className="md:w-[45px] md:h-[45px] h-[15px] w-[15px] object-contain"
        />

        {/* First Text */}
        <p className="text-black text-[6px] md:text-[24px]">
          South Africa's National Development Plan (<span className="font-bold">NDP</span>)
        </p>

        {/* Second Image */}
        <img
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745837904/image_1714_xyfvyj.png"
          alt="SDG Icon"
          className="md:w-[45px] w-[15px] h-[15px] md:h-[45px] object-contain"
        />

        {/* Second Text */}
        <p className="text-black text-[6px] md:text-[24px]">
          UN Sustainable Development Goals (<span className="font-bold">SDGs</span>)
        </p>
      </div>

    </div>
  );
}

export default Goals;
